export const settings = {
  setShareTitle: 'Dela app',
  setNotifiationsTitle: 'Notifikationer',
  setContactAppOwnerTitle: 'Kontakta appägaren',
  setContactDevelopersTitle: 'Kontakta utvecklarna',
  setReportAppTitle: 'Rapportera app',
  setDeleteAccountTitle: 'Ta bort konto',
  setLogOutTitle: 'Logga ut',
  setShareAppCurtainTitle: 'Dela app',
  setShareAppCurtainButtonTitle: 'Kopiera länk',
  setShareAppAlertWhenAppLinkWasCopied: 'Länk kopierad!',
  setNotificationsInAppTitle: 'I appen',
  setNotificationsPushContent: 'Push',
  setNotificationsChatsTitle: 'Chattar',
  setNotificationsDiscussionsTitle: 'Diskussioner',
  setNotificationsNewsTitle: 'Nyhetsflöde',
  setNotificationsEventsTitle: 'Händelser',
  setNotificationsAdminTitle: 'Admin-meddelanden',
  setNotificationsBlogTitle: 'Blogg',
  setNotificationsPushOffContent: 'Push-meddelanden är avstängda',
  setNotificationsPushOffText: 'För att aktivera push-meddelanden, gå till enhetens inställningar och aktivera notifikationer',
  setReportAppFlagCurtainTitle: 'Rapportera',
  setAppReportedCurtainContent: 'Innehåll rapporterat',
  setDeleteCurtainTitle: 'Ta bort konto',
  setDeleteCurtainInputContent: 'Lösenord',
  setDeleteCurtainCancelButtonTitle: 'Avbryt',
  setDeleteCurtainConfirmButtonTitle: 'Bekräfta',
  setDeleteCurtainIncorrectPasswordAlertText: 'Fel lösenord',
  setTurnNotificationsOnText: 'För att aktivera dem, klicka på knappen nedan och tillåt mottagande av notifikationer.',
  setTurnNotificationsOnButton: 'Aktivera push-notifikationer',
  changeLanguage: 'Byt app-språk',
  changeLanguageAlertSuccess: 'App-språket har ändrats framgångsrikt'
}
